module.exports = __webpack_public_path__ + "media/images/dummy-thumbnail2-3f0d32927e48e356666f73b5c37179d2.jpg";